



































































import {
  Vue,
  Component,
  Prop,
  InjectComponent,
  VueComponent,
  Marking,
  ProductProperty,
  ComponentStyle,
  ComponentConfig,
  ComponentStyleDefinition,
  ProductRecommendation,
} from "@zoovu/runner-browser-api";
import { ProductButtonConfiguration } from "@zoovu/runner-web-design-base/src/configuration";

@Component({})
export default class TopProductView extends Vue {
  @Prop()
  private recommendation: ProductRecommendation;

  @Prop({ default: false })
  isBundle!: boolean;

  @ComponentStyle()
  componentStyle: ComponentStyleDefinition;

  @ComponentConfig(ProductButtonConfiguration)
  private productButtonConfiguration;

  @InjectComponent("ProductRatingView")
  productRatingView: VueComponent;

  @InjectComponent("ProductComparisonSelectorView")
  productComparisonSelectorView: VueComponent;

  @InjectComponent("ProductPriceView")
  productPriceView: VueComponent;

  @InjectComponent("ProductClickoutLinkView")
  productClickoutLinkView: VueComponent;

  @InjectComponent("ProductAddToCartView")
  productAddToCartLinkView: VueComponent;

  private attributesCollapsed = false;

  private resolveClass = (marking: Marking): string => {
    switch (marking) {
      case Marking.POSITIVE:
        return "positive-property";
      case Marking.NEGATIVE:
        return "negative-property";
      case Marking.NEUTRAL:
        return "neutral-property";
      default:
        return "";
    }
  };

  public onShowMoreClicked(): void {
    this.attributesCollapsed = !this.attributesCollapsed;
  }

  public get shouldRenderProperties(): boolean {
    return this.recommendation.properties.length > 0;
  }

  public shouldRenderProperty(property: ProductProperty): boolean {
    return this.attributesCollapsed || property.marking !== Marking.NEUTRAL;
  }

  get hasNeutralProperty(): boolean {
    return this.recommendation.properties.some((property: ProductProperty) => property.marking === Marking.NEUTRAL);
  }

  public get shouldShowGoToProductButton(): boolean {
    return this.productButtonConfiguration ? this.productButtonConfiguration.showGoToProductButton : true;
  }

  public get shouldShowAddToCartButton(): boolean {
    return this.productButtonConfiguration ? this.productButtonConfiguration.showAddToCartButton.enabled : false;
  }

  public getPropertyValue(propertyName: string): unknown {
    if (!this.recommendation.additionalProperties[propertyName]) {
      const foundProperty = this.recommendation.productDefinition[propertyName];
      if (!foundProperty) return null;
      if (foundProperty instanceof Object) {
        return foundProperty.value;
      }
      return foundProperty;
    }
    const additionalProperty = this.recommendation.additionalProperties[propertyName];
    return additionalProperty.valueTranslation || additionalProperty.value;
  }
}
